<div class="text-dark mt-3">
  <div class="row">
    <div class="form-group col-12 col-lg-3">
      <label for="Scope">{{ 'RECIPIENT_LEVEL' | translate }}</label>
      <select
        id="Scope"
        [(ngModel)]="selectedScope"
        class="form-control"
        (change)="scopeChanged()"
        [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false"
      >
        <option [ngValue]="null" *ngIf="hasUnique == false">{{ 'SELECT' | translate }}</option>
        <option [ngValue]="0" *ngIf="hasCommunication == true">
          {{ 'ALL_PEOPLE' | translate }}</option>
        <option [ngValue]="1" *ngIf="hasCommunication == true">
          {{ 'CHURCH_MEMBERS' | translate }}</option>
        <option [ngValue]="2" *ngIf="hasCommunication == true">
          {{ 'CHURCH_GUESTS' | translate }}</option>
        <option [ngValue]="3" *ngIf="hasDepartments == true">{{ 'DEPARTMENT' | translate }}</option>
        <option [ngValue]="4" *ngIf="hasSuperGroups == true">
          {{ 'GROUP_COLLECTION' | translate }}</option>
        <option [ngValue]="5" *ngIf="hasGroups == true">{{ 'GROUP' | translate }}</option>
      </select>
    </div>
    <div class="form-group col-12 col-lg-3" *ngIf="selectedScope > 2">
      <label for="DetailedScope">{{ 'RECIPIENT_DETAILS' | translate }}</label>
      <select
        id="DetailedScope"
        [(ngModel)]="detailedScope"
        [class.classicRTL]="globalService.isRTL == true"
        [class.classic]="globalService.isRTL == false"
        (change)="detailChanged()"
        class="form-control"
      >
        <option [ngValue]="null" *ngIf="getScopeArr().length > 1">
          {{ 'SELECT' | translate }}</option>
        <option *ngFor="let scope of getScopeArr()" [ngValue]="scope.id">
          {{ scope.name | resourceLabel:scope:'name' }}
        </option>
      </select>
    </div>
  </div>
</div>
